<template>
  <div class="content__column content__column--small">
    <h1 class="content__title">Lista de Cupones</h1>
    <div class="results" v-if="cupons">
      <div
        class="results__element"
        v-for="(cupon, index) in cupons"
        :key="index"
      >
        <div class="results__info">
          <h2 class="results__title">Código: {{ cupon.code }}</h2>
          <p class="results__text" v-if="cupon.expiration_date">
            Expiración: {{ cupon.expiration_date | longDate("es-MX") }}
          </p>
          <p class="results__text">Uso: {{ cupon.usage_name }}</p>
        </div>
        <div class="results__actions">
          <button
            @click.prevent="$parent.$emit('view', cupon.id)"
            class="btn btn__icon btn__icon--regular results__btn results__btn--view"
          >
            Ver Cupón
          </button>
          <button
            @click.prevent="$parent.$emit('edit', cupon.id)"
            class="btn btn__icon btn__icon--regular results__btn results__btn--edit"
          >
            Editar Cupón
          </button>
          <button
            @click.prevent="deleteCupon(cupon.id)"
            class="btn btn__icon btn__icon--regular results__btn results__btn--delete"
          >
            Borrar Cupón
          </button>
        </div>
      </div>
    </div>
    <div class="information" v-else>
      <p class="information__text">No se encontraron resultados</p>
    </div>
    <confirmation v-if="confirm" @cancel="confirm = false"></confirmation>
  </div>
</template>

<script>
import httpService from "@/core/api/request";
import confirmation from "@/components/layout/confirmation";
export default {
  props: {
    filters: {
      type: String,
      required: false,
      default: function() {
        return "";
      }
    }
  },
  mixins: [httpService],
  components: { confirmation },
  data: function() {
    return {
      cuponId: null,
      cupons: null,
      confirm: false
    };
  },
  created: function() {
    this.getCupons();
  },
  mounted: function() {
    this.$on("continue", () => {
      this.confirm = false;
      this.proccedToDelete();
    });
  },
  watch: {
    filters: function() {
      this.getCupons();
    },
    "$store.state.elementChanged": {
      handler: function() {
        this.getCupons();
      },
      deep: true
    }
  },
  methods: {
    getCupons: function() {
      let httpRequest = {
        params: "?" + this.filters,
        module: "discount_cupons"
      };
      this.get(httpRequest)
        .then(cupons => {
          this.cupons = cupons.data;
        })
        .catch(() => {
          this.cupons = null;
        });
    },
    deleteCupon: function(id) {
      this.confirm = true;
      this.cuponId = id;
    },
    proccedToDelete: function() {
      let httpRequest = {
        params: "",
        module: "discount_cupons"
      };
      this.delete(this.cuponId, httpRequest)
        .then(response => {
          this.getCupons();
          this.$store.commit("notificate", {
            title: "CUPÓN BORRADO",
            text: "El cupón ha sido borrado correctamente",
            type: "success"
          });
        })
        .catch(error => {
          this.$store.commit("notificate", {
            title: "CUPÓN NO BORRADO",
            text:
              "No se pudo borrar el cupón seleccionado, por favor intente más tarde",
            type: "warn"
          });
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/discount_cupons/list.vue